import ML from './component/ML';
import Home from './component/Home';
import React, { Component } from 'react';
import NotFound from './NotFound';
import { Link, BrowserRouter as Router, Route, Switch } from 'react-router-dom';

class App extends Component {
  render() {
    return (
      <Router basename={process.env.PUBLIC_URL}>
        <div className="App">
          <Link to="/"></Link>
          <Link to="/ml"></Link>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path={process.env.PUBLIC_URL + '/ml'} component={ML} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </Router>
    );
  }
}
export default App;
